import axios from 'axios'

const $csrfToken = document.querySelector('[name=csrf-token]')
export const csrfToken = $csrfToken ? $csrfToken.content : null;
const instance = axios.create();
instance.defaults.baseURL = '/api';
instance.defaults.headers.common['X-CSRFTOKEN'] = csrfToken
export {instance as axios}
